<ion-app>
  <ion-router-outlet main></ion-router-outlet>
</ion-app>